export const CATALYST_CLASS = 'Catalyst class';
export const CATALYST_DOMAIN = 'Catalyst domain';
export const CATALYST_CLASS_ERROR = 'class_error';
export const CATALYST_DOMAIN_ERROR = 'domain_error';
